var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup39(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.872.359c-5.46-1.04-9.821.18-13.087 3.658C3.52 7.496 1.258 11.14 0 14.947l5.81 6.132c5.956-2.353 10.01-5.427 12.164-9.224C20.127 8.058 20.759 4.226 19.872.36z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E8F5FD",
    width: 50,
    height: 50,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.07 28.18c-1.7 1.463-2.827 3.016-3.38 4.66-.827 2.466-.788 4.423-.513 4.871.274.448 3.22.448 5.121-.53 1.268-.654 2.624-1.79 4.068-3.408L16.07 28.18z",
    fill: "#FFE137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.816 27.473c.128 1.685-.229 3.429-1.07 5.231-1.26 2.705-3.264 4.065-3.782 4.065-.345 0-1.095-1.355-2.25-4.065l7.102-5.231zM17.069 24.717c-2.504-1.043-3.818-1.797-3.94-2.261-.184-.697 1.75-3.06 4.261-4.263 1.674-.802 3.302-1.11 4.885-.922l-5.206 7.446z",
    fill: "#005776"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.74 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.996.64c-.134 2.246.588 4.094 2.165 5.543 1.577 1.448 3.365 2.173 5.362 2.173l1.816-2.852-.852-5.979-7.41-.415L11.996.64z",
    fill: "#005776",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.81 6.15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#009ED7",
    cx: 3.195,
    cy: 3.321,
    rx: 3.195,
    ry: 3.321
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#48CFFF",
    cx: 3.195,
    cy: 3.321,
    rx: 1.775,
    ry: 1.845
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m16.404 32.245 6.197-6.44a.6.6 0 0 1 .864 0l.172.179a.6.6 0 0 1 0 .832l-6.197 6.44a.6.6 0 0 1-.865 0l-.171-.179a.6.6 0 0 1 0-.832z",
    fill: "#009ED7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup39);
export default __webpack_public_path__ + "static/media/group-39.6607e75293f610c4aaf7f2e6543a9eb9.svg";
export { ForwardRef as ReactComponent };